export default __webpack_public_path__ + "static/media/csv-up.3edf10a0.svg";